import { render, staticRenderFns } from "./_foot.vue?vue&type=template&id=198ba097&scoped=true&"
import script from "./_foot.vue?vue&type=script&lang=js&"
export * from "./_foot.vue?vue&type=script&lang=js&"
import style0 from "./_foot.vue?vue&type=style&index=0&id=198ba097&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ba097",
  null
  
)

export default component.exports